module.exports = __webpack_public_path__ + "static/img/mhp-ss.6c39a318.png";